export default __webpack_public_path__ + "static/media/nufarEnd-Test.b933b411.png";